<template>
    <aside class="collapse_elements-container">
        <similar-products-collapse/>
        <product-price-collapse :temperatureCondition="checkTemperatureCondition" />

        <router-link to="/selection_of_the_offer" custom v-slot="{ href, navigate }" class="route-link" :class="{disabled_link: isAvalible || countSimilarFans == 0 || !isLogged}">
            <a v-if="checkTemperatureCondition" @click="alertTemperatureCondition()">
                <h2>{{translate("selection")}}</h2>
                <span class="icon-right_arrow"/>
            </a>
            <a v-else :href="href" @click="navigate">
                <h2>{{translate("selection")}}</h2>
                <span class="icon-right_arrow"/>
            </a>
        </router-link>

        <router-link to="/fan_comparison" class="route-link" :class="{disabled_link: isAvalible ||  countSimilarFans == 0 || !isLogged}">
            <h2>{{translate("power_saving")}}</h2>
            <span class="icon-right_arrow"/>
        </router-link>

        <router-link to="detail_analysis" class="route-link" :class="{disabled_link: isAvalible ||  countSimilarFans == 0 || !isLogged}">
            <h2>{{translate("detailed_analysis")}}</h2>
            <span class="icon-right_arrow"/>
        </router-link>

        <a :href="measurementLink" class="route-link" target="_blank" v-if="$store.getters.getUserRole === 'admin'" :class="{disabled_link: isAvalible ||  countSimilarFans == 0 || !isLogged}">
            <h2>{{translate("admin_analysis")}}</h2>
            <span class="icon-right_arrow"/>
        </a>

        <router-link to="adjust_engine" class="route-link" v-if="$store.getters.getUserRole === 'admin'" :class="{disabled_link: isAvalible ||  countSimilarFans == 0 || !isLogged}">
            <h2>{{translate("engine")}}</h2>
            <span class="icon-right_arrow"/>
        </router-link>

        <div class="route-link" target="_blank" v-if="getConnections && getConnections.view" :class="{disabled_link: isAvalible ||  countSimilarFans == 0 || !isLogged}" @click="openPositionsModal()">
            <h2>{{translate("conn")}}</h2>
            <span class="icon-right_arrow"/>
        </div>

        <transition name="fade" mode="out-in" appear>
            <div class="positions-modal" v-if="positionsModalVisible">
                <div class="background" @click="closePositionsModal()"></div>
                <div class="modal-content">
                    <button type="button"
                            class="btn-close"
                            @click="closePositionsModal()"> x
                    </button>
                    <connections :data="getConnections" />
                </div>
            </div>
        </transition>

    </aside>
</template>

<script>

    import ProductPriceCollapse from "@/components/configuration_steps/fourthStep/ProductPriceCollapse";
    import DetailedGraphsCollapse from "@/components/configuration_steps/fourthStep/DetailedGraphsCollapse";
    import SimilarProductsCollapse from "@/components/configuration_steps/fourthStep/SimilarProductsCollapse";
    import connections from "@/components/ResultForm/connections";

    export default {
        name: "CollapseElementsAside",
        data() {
            return {
                isAvalible: false,
                positionsModalVisible: false
            }
        },
        components: {
            ProductPriceCollapse,
            DetailedGraphsCollapse,
            SimilarProductsCollapse,
            connections
        },
        methods: {

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                };

                this.$store.commit(arg);

                return arg.out;
            },

            manageSelectedFan(){
                this.$store.commit({
                    type: 'manageSelectedFan',
                });
            },

            openPositionsModal() {
                this.positionsModalVisible = true;
            },

            closePositionsModal() {
                this.positionsModalVisible = false;
            },

            alertTemperatureCondition() {
                this.$notifications.add('warning_temp', this.translate('warning_too_high_temperature'), this.translate('high_temperature_fan_needed'));
                this.$emit('close');
            },
        },
        computed: {
            countSimilarFans() {
                this.manageSelectedFan();

                if (this.$store.state.fansTableData.FanTableRef)
                    return this.$store.state.fansTableData.FanTableRef.allFilteredData.length;
                else
                    return 0;
            },

            isLogged() {
                return this.$store.getters.getIfUserLogged;
            },

            // NVS-84 Pobranie danych przyłączy
            getConnections() {
                if (this.$store.state.activeFun && this.$store.state.activeFun.selectedFanData) {
                    return this.$store.state.activeFun.selectedFanData.connections
                }
            },

            // NVS-76 Funkcja zwraca link do podglądu pomiaru przypisanego do wyświetlonego wentylatora w zależności od środowiska (dev, prod)
            measurementLink () {
                if (this.$store.state.activeFun && this.$store.state.activeFun.selectedFanData) {
                    const measurementId = this.$store.state.activeFun.selectedFanData.id_measurement
                    const baseUrl = window.location.origin.includes('dev') ? 'https://admin.dev.nvselection.com' : 'https://admin.wentylatory.netecs.pl'
                    const url = '/Went/measurements/show/id/'
                    return baseUrl + url + measurementId
                }
                return ''
            },

            // NVS-44 Funkcja sprawdza czy jest aktywny warunek sprawdzania wzrostu temperatury w danym typie wentylatora i zwraca true jeżeli suma temperatury z doboru i wzrostu jest większa od temperatury maksymalnej wentylatora
            checkTemperatureCondition() {
                if (this.$store.state.activeFun && this.$store.state.activeFun.selectedFanData) {
                    if (this.$store.state.activeFun.params.fan_temperature_increase)
                        return this.$store.state.selectedFirstStepElement.delta_t_condition_check == 1 && this.$store.state.fourthStepParametersSelected.temperature.value - 273.15 + this.$store.state.activeFun.params.fan_temperature_increase - 273.15 > parseFloat(this.$store.state.activeFun.selectedFanData.medium_temperature_to);
                    else 
                        return this.$store.state.selectedFirstStepElement.delta_t_condition_check == 1 && this.$store.state.fourthStepParametersSelected.temperature.value - 273.15 > parseFloat(this.$store.state.activeFun.selectedFanData.medium_temperature_to);
                }
                return true
            }
        }
    }
</script>